export { default } from "./TabContent-component";
